/**
 * Configure the native status bar when the app runs inside Capacitor
 * (iOS / Android). On a regular browser / PWA this is a no-op : the
 * status bar appearance is then handled by the manifest `theme_color`
 * and the `apple-mobile-web-app-status-bar-style` meta tag.
 *
 * Goals :
 *  - status bar always visible (not fullscreen)
 *  - background = Mibeko brand blue (#0F2845)
 *  - light icons (white) on top of the dark background
 *  - native bar does NOT overlay the web content
 */
export async function configureNativeStatusBar() {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (!Capacitor?.isNativePlatform?.()) return;

    const { StatusBar, Style } = await import('@capacitor/status-bar');

    // Don't let the status bar float on top of the WebView.
    await StatusBar.setOverlaysWebView({ overlay: false });
    // Mibeko brand blue behind the system icons.
    await StatusBar.setBackgroundColor({ color: '#0F2845' });
    // White system icons on the dark background (light content).
    await StatusBar.setStyle({ style: Style.Dark });
    // Make sure the bar is shown (and not hidden by a previous session).
    await StatusBar.show();
  } catch (err) {
    // Non-fatal : the plugin may not be available in the browser preview.
    if (typeof console !== 'undefined') {
      console.info('[Mibeko] StatusBar config skipped:', err?.message || err);
    }
  }
}
